import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiEndpoint } from 'app/agriculture/queries/apiEndpoints';
import { Invitation } from 'app/agriculture/queries/invitations/types/Invitation';
import { AgricultureToastType } from 'app/agriculture/AgricultureToast/agriculture_toast_service';
import { use } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';
import { createAxiosInstance } from 'app/agriculture/queries/createAxiosInstance';
import { removeFromCache } from 'app/agriculture/mutations/utils/removeFromCache';

export function useInvitationDismissMutation() {
    const { agricultureToastService } = use(ServicesContext);
    const instance = createAxiosInstance();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async function (invitation: Invitation) {
            await instance.delete<unknown>(`${ApiEndpoint.invitations}${invitation.id}/`);

            return invitation;
        },
        onSuccess: async function (dismissedInvitation: Invitation) {
            // remove the invitation from the farm invitations query cache
            removeFromCache(dismissedInvitation, {
                queryClient,
                queryKey: [ApiEndpoint.invitations, { farmId: dismissedInvitation.farmId }],
            });

            // remove the invitation from the user invitations query cache
            removeFromCache(dismissedInvitation, {
                queryClient,
                queryKey: [ApiEndpoint.invitations, { email: dismissedInvitation.email }],
            });

            await agricultureToastService.showToast({
                title: 'Invitation dismissed',
                type: AgricultureToastType.SUCCESS,
                variant: 'simple',
            });
        },
        onError: async function (error) {
            console.error('Error dismissing invitation', error);
            await agricultureToastService.showToast({
                title: 'There was a problem dismissing this invitation',
                type: AgricultureToastType.ERROR,
                variant: 'simple',
            });
        },
    });
}
